var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burger__menu",on:{"click":function (e) { return _vm.$emit('click', e); }}},[_c('div',{staticClass:"burger__row"}),_vm._v(" "),_c('div',{staticClass:"burger__row"}),_vm._v(" "),_c('div',{staticClass:"burger__row"})])}
var staticRenderFns = []

export { render, staticRenderFns }